var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 771.682,
    height: 428.22,
    viewBox: "0 0 771.682 428.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1865",
    "data-name": "Group 1865",
    transform: "translate(-454.159 -197.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1864",
    "data-name": "Group 1864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5738",
    "data-name": "Path 5738",
    d: "M114.375-158.295H83.722V-420.9H-53.07l-63.592,262.6V-89.67H1.83V0H83.722V-89.67h30.652Zm-158.295,0,39.8-186.2H1.83v186.2Z",
    transform: "translate(570.821 618.521)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5737",
    "data-name": "Path 5737",
    d: "M59.017-158.295H28.365V-420.9H-108.428l-63.592,262.6V-89.67H-53.528V0H28.365V-89.67H59.017Zm-158.295,0,39.8-186.2h5.947v186.2Zm197.64,43h59.475L170.19-420.9H86.01ZM128.1,7.32c24.247,0,43.92-19.672,43.92-43.462S152.347-79.6,128.1-79.6,84.18-59.932,84.18-36.142,103.852,7.32,128.1,7.32Z",
    transform: "translate(1053.821 618.521)",
    fill: "#e4e4e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1863",
    "data-name": "Group 1863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5739",
    "data-name": "Path 5739",
    d: "M16.646,7.8l8.39,3.882-7.8,4.969-3.882,8.39-4.969-7.8L0,13.359,7.8,8.39,11.677,0Z",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 945.51, 491.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5740",
    "data-name": "Path 5740",
    d: "M45.2,185.288l11.6,5.367-10.778,6.87-5.367,11.6-6.87-10.778-11.6-5.367,10.778-6.871,5.367-11.6Z",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 561.062, 141.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5741",
    "data-name": "Path 5741",
    d: "M9.329,4.425,13.871,6.77,9.447,9.329,7.1,13.871,4.543,9.446,0,7.1,4.425,4.543,6.77,0Z",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 975.733, 479.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5742",
    "data-name": "Path 5742",
    d: "M34.7,16.456l16.89,8.721L35.135,34.7l-8.721,16.89L16.9,35.129,0,26.414,16.456,16.9,25.177,0Z",
    transform: "matrix(0.996, -0.087, 0.087, 0.996, 1154.304, 559.776)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1862",
    "data-name": "Group 1862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5743",
    "data-name": "Path 5743",
    d: "M327.118,163.331A162.675,162.675,0,1,1,164.443.656,162.674,162.674,0,0,1,327.118,163.331",
    transform: "translate(594.407 292.969) rotate(-7)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1861",
    "data-name": "Group 1861",
    transform: "translate(-260.715 -0.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5730",
    "data-name": "Path 5730",
    d: "M4.214,171.854A138.1,138.1,0,1,0,104.409,4.214,138.1,138.1,0,0,0,4.214,171.854",
    transform: "matrix(0.946, 0.326, -0.326, 0.946, 954.158, 257.022)",
    fill: "#d9ff50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5731",
    "data-name": "Path 5731",
    d: "M.515,90.035c-1.174,11,11.956,10.18,20.162,13.463C13.291,69.03,19.036,33.74,29.705.092-.66-2.369,2.622,45.229.067,66.488c-.19,7.812.042,15.7.447,23.548",
    transform: "matrix(0.946, 0.326, -0.326, 0.946, 1031.389, 347.811)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5732",
    "data-name": "Path 5732",
    d: "M8.663,80.595c2.87,6.593,11.731,8.842,18.3,7.849,11.71-1.772,1.837-11.352-.634-19.011a80.512,80.512,0,0,1-3.492-24.621c-.008-9.463,2.916-19.551,3.881-29.3.314-3.155,2.341-10.237.51-13.025C19.939-8.612,3.012,20.727,1.808,25.761c-4.32,18.059-.447,38.056,6.855,54.834",
    transform: "matrix(0.946, 0.326, -0.326, 0.946, 1057.51, 382.549)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5733",
    "data-name": "Path 5733",
    d: "M138.12,20.916c-6.732-11.49-18.254-24.77-32.587-19.869-11.454,3.4-18.289,12.847-26.3,21.435-16.452,17.77-37.729,8.664-57.189,4.485C10.716,24.611,1.929,34.889,0,45.149",
    transform: "matrix(0.94, 0.342, -0.342, 0.94, 970.808, 457.091)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5734",
    "data-name": "Path 5734",
    d: "M11.758,2.123A6.825,6.825,0,0,0,4.284.485,6.958,6.958,0,0,0,0,6.93",
    transform: "matrix(0.94, 0.342, -0.342, 0.94, 1089.87, 521.946)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5735",
    "data-name": "Path 5735",
    d: "M0,2.792A5.539,5.539,0,0,1,6.8.371,9.771,9.771,0,0,1,13.037,6.3",
    transform: "matrix(0.94, 0.342, -0.342, 0.94, 948.226, 496.311)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5744",
    "data-name": "Path 5744",
    d: "M351.793,200.3a154.329,154.329,0,0,1-28.1,88.486A150.755,150.755,0,0,1,252.8,343.311c-29.35,10.686-62.138,11.172-91.993,2.207a154.318,154.318,0,0,1-87.7-226.893A151.451,151.451,0,0,1,139.6,58.93c28.573-12.978,60.864-15.988,91.486-9.416A154.134,154.134,0,0,1,350.031,176.821a159.388,159.388,0,0,1,1.763,23.476c.007,2.368,10.01.713,10-2.678A156.541,156.541,0,0,0,256.89,50.181,164.743,164.743,0,0,0,77.484,99.845,156.441,156.441,0,0,0,135.1,343.387c30.6,13.438,65.3,16.607,97.955,9.8a164.9,164.9,0,0,0,84.7-46.431,157.116,157.116,0,0,0,42.188-84.677,163.248,163.248,0,0,0,1.857-24.456c0-2.352-9.994-.716-10,2.678",
    transform: "translate(553.896 261.421) rotate(-7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.026bd9c82adf52b2727b97baa8c594e9.svg";
export { ForwardRef as ReactComponent };